import { HcmService } from "../../services/models/integrations/hcm";
import { formatRut } from "@/services/utils";
const moduleQx = {
  namespaced: true,
  state: {
    qxs: [],
    loading: false,
  },
  getters: {
    getQxs(state) {
      return state.qxs;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    loadQxs(state, qxs) {
      state.qxs = qxs;
    },
  },
  actions: {
    async loadQxs({ commit, state, rootGetters }) {
      state.loading = true;
      commit("loadQxs", []);
      const rut = rootGetters["patient/getPatientRut"];
      let rutWithoutFormat = formatRut(rut);
      let rutWithoutPoint = rutWithoutFormat.replaceAll(".", "");

      let qxs = await HcmService.getPatientQxs(rutWithoutPoint.split("-")[0]);
      qxs.sort((a, b) => new Date(b.GeneralData.Date) - new Date(a.GeneralData.Date));
      commit("loadQxs", qxs);
      state.loading = false;
    },
  },
};

export default moduleQx;
